var $ = require("./qsa");

var animating = false;
var request;

var noop = function () {};
var ease = v => 0.5 - Math.cos(v * Math.PI) / 2;

var animateScroll = function (element, duration = 500, done = noop) {
  if (!element) return;
  if (animating) {
    cancelAnimationFrame(request);
    animating = false;
  }

  var elementPos = getElementPosition(element);
  var start =
    document.body.scrollTop || document.documentElement.scrollTop || 0;
  var now = Date.now();
  var finish = elementPos;
  var distance = finish - start;
  if (Math.abs(distance) < 10) return;

  var frame = function () {
    var t = Date.now();
    var elapsed = t - now;
    var d = elapsed / duration;
    if (d > 1) d = 1;
    document.body.scrollTop = document.documentElement.scrollTop =
      start + distance * ease(d);
    if (elapsed > duration) {
      animating = false;
      return done();
    }
    request = requestAnimationFrame(frame);
  };

  animating = true;
  frame();
};

// Get the position where an element should display on scroll
// based on its height and position in the text.
function getElementPosition(element) {
  var availableH = window.innerHeight - $.one("#map-container").offsetHeight;
  var top = element.offsetTop;
  var height = element.offsetHeight;
  var position =
    top -
    (availableH - height) +
    $.one("#nav").offsetHeight +
    $.one("#intro-wrapper").offsetHeight;

  return position;
}

module.exports = { animateScroll };
